import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

export const Route = createFileRoute("/privacy-policy")({
  head: () => seoHead("/privacy-policy"),
  component: PrivacyPolicy,
});
